import style from '@aytm/app/stats/page/question-views/sh/components/shelf/styles/ShelfNote.module.scss'

// Randomization or logic can show respondents different shelves, so the figures under a shelf
// are read with that caveat; the shelf-test and ecommerce questions both carry it.
const ShelfNote = () => (
  <div data-testid="stat-shelf-note" className={style.note}>
    <b>Please note:</b> if randomization and/or aytm Logic was used, some respondents may have seen a different shelf
    set up
  </div>
)

export default ShelfNote
